import { ModeType } from "../rest.interface";

enum ActionsEnum {
	Mode = 'MODE_CHANGE',
	Zoom = 'ZOOM_CHANGE',
}

type StateMode = {
	mode: ModeType,
	zoom: number
}

export type ActionMode = {
	mode?: ModeType,
	zoom?: number,
	type: ActionsEnum
}

export const actionModeChange = (newMode: ModeType): ActionMode => ({
	type: ActionsEnum.Mode,
	mode: newMode
});

export const actionZoomChange = (newZoom: number = 100): ActionMode => ({
	type: ActionsEnum.Zoom,
	zoom: newZoom
});

export const reducerMode = (state = null as StateMode, action: ActionMode): StateMode => {
	if (state === null) {
		state = { mode: ModeType["w-full"], zoom: 100 };

		if (localStorage.getItem('zoom')) {
			state.zoom = Number(localStorage.getItem('zoom'));
		}

		if (localStorage.getItem('mode')) {
			state.mode = localStorage.getItem('mode') as ModeType;
		}
	}

	switch (action.type) {
		case ActionsEnum.Mode:
			localStorage.setItem('mode', action.mode);

			return {
				...state,
				mode: action.mode
			};

		case ActionsEnum.Zoom:
			localStorage.setItem('zoom', action.zoom.toString());

			return {
				...state,
				zoom: action.zoom
			};

		default:
			return state
	}
};
